var Reflux = require('reflux');

module.exports = Reflux.createActions([
  "fetchExperiences",
  "showExperience"
]);



// WEBPACK FOOTER //
// ./src/advocate/challenges/actions/experiences_actions.js